<template>
    <div class="product-listing__switch align-self-center">
        <span class="product-listing__switch--list" @click="setLayout('list')" :class="{'text-primary': active === 'list'}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="15">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-list-view"></use>
            </svg>
        </span>
        <span class="product-listing__switch--tiles" @click="setLayout('tiles')" :class="{'text-primary': active === 'tiles'}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="15">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-tile-view"></use>
            </svg>
        </span>
    </div>
</template>

<script>
import {getCookie, setCookie} from '~/app/helper/Cookie';

export default {
    data() {
        return {
            active: 'tiles',
            cookie: null,
            windowWidth: 0
        }
    },
    computed: {
        isMobile() {
            return this.windowWidth < 768;
        }
    },
    mounted() {

        this.windowWidth = window.innerWidth;
        this.cookie = getCookie('category_layout_type');

        if(this.cookie === 'list') {
            this.active = 'list';
        }
    },
    methods: {
        setLayout(type) {

            let category = document.querySelector('#js--product-list');

            if (category !== null) {

                this.active = type;

                if (this.active === 'list') {
                    category.classList.add('product-list--list');
                    setCookie('category_layout_type', 'list')
                } else {
                    category.classList.remove('product-list--list');
                    setCookie('category_layout_type', 'tiles')
                }
            }
        }
    }
}
</script>
